import { createFileRoute } from '@tanstack/react-router';
import { EditBusinessDetails } from '@/features/business/components/edit/EditBusinessDetails';

export const Route = createFileRoute('/(app)/(store)/store/edit/business')({
  component: RouteComponent,
});

function RouteComponent() {
  return <EditBusinessDetails />;
}
